<button *ngIf="global_texts" class="toggle-button btn btn-solid-black btn-small"
        [ngClass]="{'is-open': is_sidebar_visible}"
        (click)="toggleSidebar()">
	<span *ngIf="!is_sidebar_visible" class="d-flex align-items-center">
		<span class="material-icons me-2">visibility</span>
		<span class="lh-base" [innerHtml]="global_texts.steps"></span>
	</span>

  <span *ngIf="is_sidebar_visible" class="d-flex align-items-center justify-content-center">
		<span class="material-icons me-2">close</span>
		<span class="lh-base" [innerHtml]="global_texts.close"></span>
	</span>
</button>

<div class="overlay" [ngClass]="{'visible':is_sidebar_visible}"></div>

<div class="position-relative sb-content pt-3 pt-lg-5" [ngClass]="{'visible':is_sidebar_visible}">
  <div role="button" [routerLink]="'/'">
    <!--    <img class="img-sidebar p-4" alt="chess" src="/assets/images/chess_panel.svg"/>-->
    <img class="img-sidebar px-2 pb-4" alt="Les Maîtres à Panser" [src]="global_texts.logo_src"/>
  </div>
  <ul class="menu-sidebar p-0 p-lg-3">
    <li *ngFor="let mod of modules">
      <a role="button" class="d-flex align-items-center"
         [attr.data-text]="mod.module_title"
         [ngClass]="app.sharedHelper.getStatusClass(mod.module_status)"
         (click)="app.sharedHelper.startOrContinueModule(mod.module_uuid)">
        <!-- Old code : app.sharedHelper.goToFirtScreen(mod.module_uuid)-->
        <svg class="me-3">
          <use [attr.xlink:href]="'#' + mod.module_icon"></use>
        </svg>
        <span [innerHtml]="mod.module_title"></span>
      </a>
    </li>
  </ul>
</div>


